export default __webpack_public_path__ + "5bd2c38b6aadc655492a397ed5b776d5.svg";